import http from "./http";

//请求会员权益
export function getMemberData() {
    let url = `/api/member/memberSetting/compare`;
    return http.get(url)
}
//我的会员
export function myMemberData() {
    let url = `/api/pcUser/member`;
    return http.get(url)
}

export function payMemberExpense(data) {

return http.post(`/api/weChat/applet/order/batch/create/order/member`,data)
}

